export default class CancelMotive {
  private $id: string;

  private $motive: string;

  constructor(id: string, motive: string) {
    this.$id = id;
    this.$motive = motive;
  }

  get id(): string {
    return this.$id;
  }

  get motive(): string {
    return this.$motive;
  }
}
